import React, { useState, useEffect } from "react";
import { FiMenu, FiX, FiPhone, FiMail } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { FiArrowRight, FiCalendar } from "react-icons/fi";
import { RiRobot2Fill } from "react-icons/ri";
import { createAppointment, clearError } from "../redux/appointmentSlice";
import { motion } from "framer-motion";

export const Navigation = (props) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [scrolled, setScrolled] = useState(false);
  const [isDesktop, setIsDesktop] = useState(window.innerWidth >= 1024);
  const [showModal, setShowModal] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [date, setDate] = useState("");
  const [phoneError, setPhoneError] = useState("");

  const dispatch = useDispatch();
  const { loading, error } = useSelector((state) => state.appointments);

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");

    if (value.startsWith("0")) {
      value = value.substring(1);
    }

    if (value.length > 10) {
      value = value.substring(0, 10);
    }

    setPhone(value);

    if (value.length > 0 && value.length < 10) {
      setPhoneError("Telefon numarası 10 haneli olmalıdır");
    } else if (value.length === 10 && !value.startsWith("5")) {
      setPhoneError("Telefon numarası 5 ile başlamalıdır");
    } else {
      setPhoneError("");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (phone.length !== 10) {
      alert("❌ Telefon numarası 10 haneli olmalıdır");
      return;
    }

    if (!phone.startsWith("5")) {
      alert("❌ Telefon numarası 5 ile başlamalıdır (örn: 5340834440)");
      return;
    }

    try {
      await dispatch(
        createAppointment({
          fullName: name,
          phone: "0" + phone,
          date,
        })
      ).unwrap();

      alert(
        "✅ Randevu talebiniz alındı! Randevu saatiniz en kısa sürede size bildirilecektir."
      );
      setName("");
      setPhone("");
      setDate("");
      setPhoneError("");
      setShowModal(false);
      dispatch(clearError());
    } catch (err) {
      alert("❌ Randevu oluşturulamadı. Tekrar deneyin.");
    }
  };

  const menuItems = [
    { id: "home", label: "Ana Sayfa", href: "#home" },
    { id: "about", label: "Misyonumuz", href: "#about" },
    { id: "services", label: "Hizmetler", href: "#services" },
    { id: "portfolio", label: "Hakkımda", href: "#portfolio" },
    { id: "testimonials", label: "Yorumlar", href: "#testimonials" },
    { id: "contact", label: "İletişim", href: "#contact" },
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsDesktop(window.innerWidth >= 1024);
      if (window.innerWidth >= 1024) {
        setMobileMenuOpen(false);
      }
    };

    const handleScroll = () => {
      setScrolled(window.scrollY > 50);

      const sections = menuItems.map((item) => item.id);
      for (const section of [...sections].reverse()) {
        const element = document.getElementById(section);
        if (element) {
          const rect = element.getBoundingClientRect();
          if (rect.top <= 150) {
            setActiveSection(section);
            break;
          }
        }
      }
    };

    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleMenuClick = (sectionId) => {
    setActiveSection(sectionId);
    setMobileMenuOpen(false);
    const element = document.getElementById(sectionId);
    element?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      style={{
        position: "fixed",
        width: "100%",
        top: 0,
        zIndex: 50,
        boxShadow: scrolled ? "0 4px 6px -1px rgba(0, 0, 0, 0.1)" : "none",
        transition: "all 0.3s ease",
      }}
    >
      {/* Üst Bar - İletişim Bilgileri */}
      <div
        style={{
          backgroundColor: "#1e3a5f",
          color: "white",
          padding: "8px 0",
        }}
      >
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            padding: "0 24px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              gap: "24px",
              fontSize: "14px",
            }}
          >
            <a
              href="tel:+905055517747"
              style={{
                display: "flex",
                alignItems: "center",
                color: "white",
                textDecoration: "none",
              }}
            >
              <FiPhone size={14} style={{ marginRight: "8px" }} />
              <span>+90 505 551 77 47</span>
            </a>
           
          </div>
        </div>
      </div>

      {/* Ana Navbar */}
      <nav style={{ backgroundColor: "white" }}>
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
            padding: "0 24px",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              height: "80px",
            }}
          >
            {/* Logo */}
            <div style={{ display: "flex", alignItems: "center" }}>
              <a href="/">
                <img
                  src="/img/logo.png"
                  alt="Dilan Aslan Logo"
                  style={{ height: "48px", width: "auto" }}
                />
              </a>
            </div>

            {/* Desktop Menu */}
            {isDesktop && (
              <div
                style={{ display: "flex", alignItems: "center", gap: "4px" }}
              >
                {menuItems.map((item) => (
                  <button
                    key={item.id}
                    onClick={() => handleMenuClick(item.id)}
                    style={{
                      padding: "8px 16px",
                      borderRadius: "8px",
                      fontSize: "14px",
                      fontWeight: "500",
                      border: "none",
                      cursor: "pointer",
                      transition: "all 0.2s ease",
                      backgroundColor:
                        activeSection === item.id ? "#eff6ff" : "transparent",
                      color: activeSection === item.id ? "#2563eb" : "#374151",
                    }}
                  >
                    {item.label}
                  </button>
                ))}

                {/* AI Asistan Button */}
                <a
                  href="/asistan"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    marginLeft: "12px",
                    padding: "10px 20px",
                    borderRadius: "50px",
                    fontSize: "14px",
                    fontWeight: "600",
                    border: "none",
                    cursor: "pointer",
                    textDecoration: "none",
                    background:
                      "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
                    color: "white",
                    boxShadow: "0 4px 15px rgba(20, 184, 166, 0.3)",
                    transition: "all 0.3s ease",
                    position: "relative",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-2px)";
                    e.currentTarget.style.boxShadow =
                      "0 6px 20px rgba(20, 184, 166, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(20, 184, 166, 0.3)";
                  }}
                >
                  <RiRobot2Fill size={18} />
                  <span>AI Asistan</span>
                  <span
                    style={{
                      position: "absolute",
                      top: "-8px",
                      right: "-8px",
                      background:
                        "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                      color: "white",
                      fontSize: "10px",
                      fontWeight: "700",
                      padding: "2px 6px",
                      borderRadius: "50px",
                    }}
                  >
                    YENİ
                  </span>
                </a>

                {/* CTA Button */}
                <button
                  onClick={() => setShowModal(true)}
                  style={{
                    marginLeft: "8px",
                    backgroundColor: "#2563eb",
                    color: "white",
                    padding: "10px 24px",
                    borderRadius: "8px",
                    fontSize: "14px",
                    fontWeight: "600",
                    border: "none",
                    cursor: "pointer",
                    boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
                    transition: "all 0.2s ease",
                  }}
                >
                  Randevu Al
                </button>
              </div>
            )}

            {/* Mobile Menu Button */}
            {!isDesktop && (
              <button
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "8px",
                  borderRadius: "8px",
                  border: "none",
                  backgroundColor: "transparent",
                  cursor: "pointer",
                  color: "#374151",
                }}
              >
                {mobileMenuOpen ? <FiX size={28} /> : <FiMenu size={28} />}
              </button>
            )}
          </div>
        </div>

        {/* Mobile Menu */}
        {!isDesktop && mobileMenuOpen && (
          <div
            style={{
              backgroundColor: "white",
              borderTop: "1px solid #f3f4f6",
              boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              padding: "16px",
            }}
          >
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleMenuClick(item.id)}
                style={{
                  display: "block",
                  width: "100%",
                  textAlign: "left",
                  padding: "12px 16px",
                  borderRadius: "12px",
                  fontSize: "16px",
                  fontWeight: "500",
                  border: "none",
                  cursor: "pointer",
                  marginBottom: "8px",
                  backgroundColor:
                    activeSection === item.id ? "#eff6ff" : "transparent",
                  color: activeSection === item.id ? "#2563eb" : "#374151",
                }}
              >
                {item.label}
              </button>
            ))}

            {/* Mobile AI Asistan Button */}
            <a
              href="/asistan"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                width: "100%",
                padding: "12px 24px",
                borderRadius: "12px",
                fontSize: "16px",
                fontWeight: "600",
                textDecoration: "none",
                background: "linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)",
                color: "white",
                marginBottom: "8px",
                position: "relative",
                boxSizing: "border-box",
              }}
            >
              <RiRobot2Fill size={20} />
              <span>AI Asistan</span>
              <span
                style={{
                  background:
                    "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
                  color: "white",
                  fontSize: "10px",
                  fontWeight: "700",
                  padding: "2px 8px",
                  borderRadius: "50px",
                  marginLeft: "8px",
                }}
              >
                YENİ
              </span>
            </a>

            {/* Mobile CTA Button */}
            <button
              onClick={() => setShowModal(true)}
              style={{
                width: "100%",
                backgroundColor: "#2563eb",
                color: "white",
                padding: "12px 24px",
                borderRadius: "12px",
                fontSize: "16px",
                fontWeight: "600",
                border: "none",
                cursor: "pointer",
              }}
            >
              Randevu Al
            </button>
          </div>
        )}
      </nav>

      {/* Randevu Modal */}
      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <motion.div
            className="bg-white rounded-2xl p-8 max-w-md w-full shadow-2xl relative"
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3 }}
          >
            <button
              onClick={() => setShowModal(false)}
              className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
            >
              <FiX size={24} />
            </button>

            <div className="text-center mb-6">
              <div className="bg-blue-100 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                <FiCalendar className="text-blue-600" size={32} />
              </div>
              <h3 className="text-2xl font-bold text-gray-900">
                Randevu Talebi
              </h3>
              <p className="text-gray-600 mt-2">
                Formu doldurun, size en kısa sürede dönüş yapalım.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Ad Soyad
                </label>
                <input
                  id="name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  placeholder="Adınızı soyadınızı girin"
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none"
                />
              </div>

              <div>
                <label
                  htmlFor="phone"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Telefon
                </label>
                <input
                  id="phone"
                  value={phone}
                  onChange={handlePhoneChange}
                  type="tel"
                  placeholder="5xx xxx xx xx"
                  required
                  maxLength="10"
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none"
                />
                {phoneError && (
                  <span className="text-red-500 text-sm mt-1 block">
                    {phoneError}
                  </span>
                )}
              </div>

              <div>
                <label
                  htmlFor="date"
                  className="block text-sm font-medium text-gray-700 mb-1"
                >
                  Tarih Seçin
                </label>
                <input
                  id="date"
                  value={date}
                  onChange={(e) => setDate(e.target.value)}
                  type="date"
                  min={new Date().toISOString().split("T")[0]}
                  required
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all outline-none"
                />
                <p className="text-gray-500 text-xs mt-2">
                  * Randevu saatiniz tarafımızca belirlenip size SMS ile
                  bildirilecektir.
                </p>
              </div>

              <button
                type="submit"
                disabled={loading || phoneError !== "" || phone.length !== 10}
                className="w-full bg-blue-600 text-white py-4 rounded-lg font-semibold hover:bg-blue-700 transition-all disabled:bg-gray-400 disabled:cursor-not-allowed flex items-center justify-center"
              >
                {loading ? (
                  <>
                    <svg
                      className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                      ></path>
                    </svg>
                    Gönderiliyor...
                  </>
                ) : (
                  <>
                    Randevu Talebi Gönder
                    <FiArrowRight className="ml-2" size={20} />
                  </>
                )}
              </button>

              {error && (
                <p className="text-red-500 text-center text-sm">
                  Hata: {error}
                </p>
              )}
            </form>
          </motion.div>
        </div>
      )}
    </header>
  );
};

export default Navigation;
